export enum OfferState {
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  AVAILABLE_OFFER = 'AVAILABLE_OFFER',
  ONGOING_FUNDING = 'ONGOING_FUNDING',
  EXPIRED_OFFER = 'EXPIRED_OFFER',
}

export type MerchantOffer = {
  merchant_id: number;
  state: OfferState;
  url?: string;
  url_valid_until?: string;
  amount?: number;
  currency?: string;
};
